export const contractTerminationReasonFeatureKey = 'contractTerminationReason';

export type ContractTerminationReasonModel = {
  id: number;
  name: string;
  active: boolean;
};
